import * as actionTypes from './actionTypes';
//import * as eventTypes from './eventTypes';
import initialState from '../../reducers/initialState';
import * as eventTypes from './eventTypes';

export default function reducer(state = initialState.tasksData, action) {
  const initialData = initialState.tasksData;
  switch (action.type) {
    //Document tasks
    case actionTypes.LOAD_DOCUMENT_TASKS_STARTED: {
      return {
        ...state,
        [action.id]: {
          tasksLoading: true
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_TASKS_SUCCEEDED: {
      return {
        ...state,
        [action.id]: {
          tasksList: action.payload,
          documentTasksIsLoaded: true,
          tasksLoading: false
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_TASKS_FAILED: {
      return {
        ...state,
        [action.id]: {
          documentTasksIsLoaded: false,
          tasksLoading: false
        }
      };
    }

    //Dashboard tasks
    case actionTypes.LOAD_DASHBOARD_TASKS_STARTED: {
      return {
        ...state,
        tasksLoading: true
      };
    }

    case actionTypes.LOAD_DASHBOARD_TASKS_SUCCEEDED: {
      return {
        ...state,
        tasks: action.payload.tasks,
        tasksLoading: false
      };
    }

    case actionTypes.LOAD_DASHBOARD_TASKS_FAILED: {
      return {
        ...state,
        tasksLoading: false
      };
    }

    case actionTypes.LOAD_TASK_OPTIONS_SUCCEEDED: {
      return {
        ...state,
        taskOptions: action.payload.taskOptions
      };
    }

    case actionTypes.LOAD_CLIENT_CATEGORIES_SUCCEEDED: {
      return {
        ...state,
        clientCategories: action.payload.clientCategories
      };
    }

    case actionTypes.LOAD_CLIENT_CATEGORIES_FAILED: {
      return {
        ...state,
        clientCategories: initialData.clientCategories
      };
    }

    case actionTypes.LOAD_TASK_TYPES_SUCCEEDED: {
      return {
        ...state,
        taskTypes: action.payload.taskTypes
      };
    }

    case actionTypes.LOAD_TASK_TYPES_FAILED: {
      return {
        ...state,
        taskTypes: initialData.taskTypes
      };
    }

    case actionTypes.LOAD_TASK_OPTIONS_FAILED: {
      return {
        ...state,
        taskOptions: initialData.taskOptions
      };
    }

    case actionTypes.LOAD_TASK_RESPONSIBLES_SUCCEEDED: {
      return {
        ...state,
        tasksResponsibles: action.payload.tasksResponsibles
      };
    }

    case actionTypes.LOAD_TASK_RESPONSIBLES_FAILED: {
      return {
        ...state,
        tasksResponsibles: initialData.tasksResponsibles
      };
    }

    case actionTypes.LOAD_TASK_STATES_SUCCEEDED: {
      return {
        ...state,
        taskStates: action.payload.taskStates
      };
    }

    case actionTypes.LOAD_TASK_STATES_FAILED: {
      return {
        ...state,
        taskStates: initialData.taskStates
      };
    }

    case actionTypes.LOAD_TASK_STATUSES_SUCCEEDED: {
      return {
        ...state,
        taskStatuses: action.payload.taskStatuses
      };
    }
    case actionTypes.LOAD_TASK_STATUSES_FAILED: {
      return {
        ...state,
        taskStatuses: initialData.taskStatuses
      };
    }

    case actionTypes.LOAD_TASKS_CONFIG_SUCCEEDED: {
      return {
        ...state,
        tasksConfig: action.payload.tasksConfig,
        tasksConfigIsLoaded: true
      };
    }

    case actionTypes.LOAD_TASKS_CONFIG_FAILED: {
      return {
        ...state,
        tasksConfigIsLoaded: false
      };
    }

    //Pause task
    case actionTypes.PAUSE_TASK_STARTED: {
      return {
        ...state,
        tasksLoading: true
      };
    }

    case actionTypes.PAUSE_TASK_SUCCEEDED: {
      return {
        ...state,
        tasksIsChanged: true,
        tasksLoading: false
      };
    }

    case actionTypes.PAUSE_TASK_FAILED: {
      return {
        ...state,
        tasksIsChanged: false,
        tasksLoading: false
      };
    }

    //Start task
    case actionTypes.START_TASK_STARTED: {
      return {
        ...state,
        tasksLoading: true
      };
    }

    case actionTypes.START_TASK_SUCCEEDED: {
      return {
        ...state,
        tasksIsChanged: true,
        tasksLoading: false
      };
    }

    case actionTypes.START_TASK_FAILED: {
      return {
        ...state,
        tasksIsChanged: true,
        tasksLoading: false
      };
    }

    //Reset tasks
    case actionTypes.RESET_TASKS: {
      return {
        ...state,
        tasksIsChanged: false
      };
    }

    //Update task responsible
    case actionTypes.UPDATE_TASK_STARTED: {
      return {
        ...state,
        tasksLoading: true
      };
    }

    case actionTypes.UPDATE_TASK_SUCCEEDED: {
      return {
        ...state,
        tasksIsChanged: true,
        tasksLoading: false
      };
    }

    case actionTypes.UPDATE_TASK_FAILED: {
      return {
        ...state,
        tasksIsChanged: false,
        tasksLoading: false
      };
    }

    // tasks responsibles
    case actionTypes.LOAD_TASKS_RESPONSIBLES_SUCCEEDED: {
      return {
        ...state,
        taskResponsiblesForSingleTask: action.payload.taskResponsiblesForSingleTask
      };
    }

    case eventTypes.DOCUMENT_TASKS_CHANGED: {
      const { documentId, siteId } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;
      return {
        ...state,
        [key]: {
          documentTasksIsLoaded: false,
          tasksList: []
        },
        tasksIsChanged: true
      };
    }

    case actionTypes.UPDATE_TASK_PRIORITY_STARTED: {
      return {
        ...state,
        tasksLoading: true
      };
    }

    case actionTypes.UPDATE_TASK_PRIORITY_SUCCEEDED: {
      return {
        ...state,
        tasksIsChanged: true,
        tasksLoading: false
      };
    }

    case actionTypes.UPDATE_TASK_PRIORITY_FAILED: {
      return {
        ...state,
        tasksIsChanged: false,
        tasksLoading: false
      };
    }

    default:
      return state;
  }
}
